import { connect } from "react-redux";

import LeftSidebar from "./LeftSidebar";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";
import {
  toggleSidebarLeft,
  switchTabOnSidebarLeft,
  selectLeftSidebarIsOpen,
  selectLeftSidebarActiveTab,
  closeSidebarLeft
} from "~/store/ducks/user/uistate";
import {
  selectIsSidebarLeftVisible,
  selectActiveTabs,
  selectShowPlannerTab,
  selectShowPagesTab,
  selectShowOutlineTab,
  selectShowBookmarksTab,
  selectVisibleTabNames,
  selectHasSingleTab
} from "~/store/ducks/domain/ui/sidebarLeft";
import { selectOutline, selectOffset } from "~/store/ducks/domain/config";
import { goToPage } from "~/store/middlewares/page";
import { selectDisplayedPages } from "~/store/selectors/page";

function mapStateToProps(state) {
  return {
    activeTab: selectLeftSidebarActiveTab(state),
    isOpen: selectLeftSidebarIsOpen(state),
    isDocked: selectIsGreaterThanMedium(state),
    isLeftSidebarVisible: selectIsSidebarLeftVisible(state),
    activeTabs: selectActiveTabs(state),
    showPlannerTab: selectShowPlannerTab(state),
    showPagesTab: selectShowPagesTab(state),
    showOutlineTab: selectShowOutlineTab(state),
    showBookmarksTab: selectShowBookmarksTab(state),
    tabNames: selectVisibleTabNames(state),
    isSingleTab: selectHasSingleTab(state),
    outline: selectOutline(state),
    offset: selectOffset(state),
    pages: selectDisplayedPages(state)
  };
}

const mapDispatchToProps = {
  toggleSidebarLeft,
  switchTabOnSidebarLeft,
  closeSidebarLeft,
  goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftSidebar);
